var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { memo } from 'react';
import { useBlock, useBlockEdit, blockEditActions } from '../';
export var CheckBox = memo(function (_a) {
    var _b, _c;
    var blockId = _a.blockId, field = _a.field, label = _a.label;
    var block = useBlock(blockId).block;
    var _d = useBlockEdit(), blockEdit = _d.blockEdit, dispatchBlockEdit = _d.dispatchBlockEdit;
    var onToggle = function (e) {
        var _a;
        dispatchBlockEdit({
            type: blockEditActions.ADD,
            block: __assign(__assign(__assign({}, block), blockEdit.data), (_a = {}, _a[e.target.name] = e.target.checked, _a))
        });
    };
    var value = ((_b = blockEdit.data) === null || _b === void 0 ? void 0 : _b[field]) !== undefined ? (_c = blockEdit.data) === null || _c === void 0 ? void 0 : _c[field] : block === null || block === void 0 ? void 0 : block[field];
    return (React.createElement("label", null,
        React.createElement("input", { type: "checkbox", name: field, checked: value, onChange: onToggle }),
        label));
});
